import { defineMessages } from "react-intl";

export const messages = defineMessages({
    // Country entity
    countryEntitySingular: {
        id: "localisation.country.entity_singular",
        defaultMessage: "Country",
    },
    countryEntityPlural: {
        id: "localisation.country.entity_plural",
        defaultMessage: "Countries",
    },
    countryEntityDefiniteArticle: {
        id: "localisation.country.entity_definite_article",
        defaultMessage: "the country",
    },
    countryEntityDemonstrative: {
        id: "localisation.country.entity_demonstrative",
        defaultMessage: "this country",
    },
    countryEntityIndefiniteArticle: {
        id: "localisation.country.entity_indefinite_article",
        defaultMessage: "a country",
    },
    // Region entity
    regionEntitySingular: {
        id: "localisation.region.entity_singular",
        defaultMessage: "Region",
    },
    regionEntityPlural: {
        id: "localisation.region.entity_plural",
        defaultMessage: "Regions",
    },
    regionEntityDefiniteArticle: {
        id: "localisation.region.entity_definite_article",
        defaultMessage: "the region",
    },
    regionEntityDemonstrative: {
        id: "localisation.region.entity_demonstrative",
        defaultMessage: "this region",
    },
    regionEntityIndefiniteArticle: {
        id: "localisation.region.entity_indefinite_article",
        defaultMessage: "a region",
    },
    regionColumnCode: {
        id: "localisation.region.columns.code",
        defaultMessage: "Region code",
    },
});
